// packages/eden-fade/src/utils/context.js
import { createContext } from "react";
var OverflowContext = createContext();
export {
  OverflowContext
};
